import {
  GET_LICENSE,
  GET_LICENSES,
  LICENSE_ERROR,
  UPDATE_LICENSE,
  CLEAR_LICENSE,
  CHECK_LICENSE
  // LICENSE_DELETED
} from '../actions/types';

const initialState = {
  license: null,
  licenses: [],
  loading: true,
  error: {},
  checkLicense: false
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_LICENSE:
    case UPDATE_LICENSE:
      return {
        ...state,
        license: payload,
        loading: false
      };
    case GET_LICENSES:
      return {
        ...state,
        licenses: payload,
        loading: false
      };
    case LICENSE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
        // license: null,
        // licenses: []
      };
    case CLEAR_LICENSE:
      return {
        ...state,
        license: null,
        licenses: [],
        loading: false
        // checkLicense: false
      };
    case CHECK_LICENSE:
      return {
        ...state,
        checkLicense: payload.data
      };
    default:
      return state;
  }
}
